import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageTextAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPageTextAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H20V13H16V16H13V20.5H16V22H4ZM7 5H15V6.5H7V5ZM7 9H11V10.5H7V9Z" fill="currentColor"/><Path d="M22 17.5H19V14.5H17.5V17.5H14.5V19H17.5V22H19V19H22V17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageTextAdd;
